export default function mobileTest(str: string) {
  const phone =
    /^((13[0-9])|(14[579])|(15[^4])|(18[0-9])|(17[0135678]))[0-9]{8}$/;
  const ring = /^((\d{3,4})|\d{3,4}-|\s)?\d{7,14}$/;
  return phone.test(str) || ring.test(str);
}

export function flexibleMobileTest(str: string) {
  const num = /^\d[\d,-]*\d$|^\d$/;
  return num.test(str);
}
